import useFeatureFlag from "../../../hooks/useFeatureFlag";
import { FEATURE_FLAGS } from "../../../constants/FeatureFlag";

export default function useFirstAccessFlow() {
  const globalFlag = useFeatureFlag(
    FEATURE_FLAGS.KILL_SWITCH.ENABLE_FIRST_ACCESS_FLOW
  );

  return {
    isFirstAccessFlowEnabled: globalFlag.isFeatureFlagEnable,
    flagsReady: globalFlag.flagsReady,
    flagResolved: globalFlag.flagResolved,
  };
}
